<div class="archived-companies-table">
	<app-component-loader [isLoading]="isLoading()">
		<a class="btn-nav btn-prev archived-companies-back mb-3" (click)="onBack()">Back To Search</a>

		@if (errorMessage()) {
			<alert type="danger" class="mb-3">{{ errorMessage() }}</alert>
		}

		<table class="table table-hover archived-companies-list">
			<thead>
				<tr>
					<th>Company Name</th>
					<th>Registration Number</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				@for (archive of archives(); track archive.id) {
					<tr
						class="archived-companies-row"
						(click)="onView(archive)"
						(mouseenter)="toggleFolderOpen(true, archive.id)"
						(mouseleave)="toggleFolderOpen(false, null)"
					>
						<td class="archived-companies-name">{{ archive.company_name || '—' }}</td>
						<td class="archived-companies-registration">{{ archive.registration_number || '—' }}</td>
						<td class="archived-companies-actions">
							<button type="button" class="dataTableButton archived-companies-folder" style="width: 25px">
								<app-icon [icon]="openFolder() && hoveredRowId() === archive.id ? faFolderOpenIcon : faFolderIcon" />
							</button>
						</td>
					</tr>
				} @empty {
					<tr class="archived-companies-empty">
						<td colspan="3">No archived companies found.</td>
					</tr>
				}
			</tbody>
		</table>
	</app-component-loader>
</div>
